import { useEffect, useState } from 'react';
import { useAuth } from '../lib/auth-context';
import { useEnterpriseOrg } from '../context/EnterpriseOrgContext';
import { type EnterpriseWorkspaceAnalytics } from '../lib/enterprise-api';
import { loadWorkspaceAnalytics } from '../lib/enterprise-work-engine';

export function useEnterpriseWorkspaceAnalytics() {
  const { accessToken } = useAuth();
  const { activeOrgId, hasActiveOrgAccess } = useEnterpriseOrg();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [analytics, setAnalytics] = useState<EnterpriseWorkspaceAnalytics | null>(null);

  useEffect(() => {
    let cancelled = false;
    if (!accessToken || !activeOrgId || !hasActiveOrgAccess) {
      setAnalytics(null);
      setError(null);
      setLoading(false);
      return;
    }
    setLoading(true);
    setError(null);
    void loadWorkspaceAnalytics(accessToken, activeOrgId)
      .then((res) => {
        if (cancelled) return;
        if (!res.success || !res.analytics) {
          setAnalytics(null);
          setError(res.error || 'Failed to load workspace analytics');
          return;
        }
        setAnalytics(res.analytics);
      })
      .catch((e) => {
        if (cancelled) return;
        setAnalytics(null);
        setError(e instanceof Error ? e.message : String(e));
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, [accessToken, activeOrgId, hasActiveOrgAccess]);

  return { loading, error, analytics };
}

